import { APPS } from '@shared/contants/app'
import { cn } from '@shared/lib/cn'
import { LocalizedLink as Link } from '@shared/lib/locale'

import styles from './styles.module.scss'

interface AppMarketProps {
  className?: string;
}

export default function AppMarket (props: AppMarketProps) {
  const { className } = props

  return (
    <div className={cn(styles.root, className)}>
      {APPS.map((item, index) => {
        return (
          <Link to={item.href} target="_blank" className={styles.root__item} key={index}>
            <img src={item.icon} alt="" loading="lazy" fetchPriority="low" />
          </Link>
        )
      })}
    </div>
  )
}
